<template>
  <a-modal
    :title="title"
    :width="1100"
    :visible="visible"
    centered
    :maskClosable="false"
    @cancel="handleCancel"
    :footer="null"
    class="pub-modal-noPadding-10"
  >
    <BasicTable
      :columns="columns"
      bordered
      :dataSource="list"
      :loading="loading"
      :pagination="false"
      :search="false"
    >
      <template #tableTitle>
        <div class="pub-tableTitle-button">
          <a-button
            type="primary"
            class="btn-green"
            icon="plus-circle"
            @click="add()"
            >添加平台</a-button
          >
        </div>
      </template>
      <template slot="platformType" slot-scope="{ record }">
        <PubStatus :status="record.platformType" type="DEVICE_SUPPLIER_CODE" />
      </template>
      <template slot="status" slot-scope="{ record }">
        <PubEnableStatus :status="record.status" />
      </template>
      <template slot="options" slot-scope="{ record }">
        <div class="pub-options">
          <a @click="add('edit', record)"> <a-icon type="form" />编辑 </a>
          <a @click="deleteDocking(record.id)" class="red">
            <a-icon type="delete" />删除
          </a>
        </div>
      </template>
    </BasicTable>
    <AddDocking ref="addDockingModal" @ok="moduleOk" />
  </a-modal>
</template>

<script>
import { SettingSchool } from "@/api";
import AddDocking from "./AddDocking.vue";
export default {
  components: {
    AddDocking,
  },
  data() {
    const columns = [
      {
        title: "平台名称",
        dataIndex: "platformType",
        align: "center",
        scopedSlots: true,
      },
      {
        title: "账户",
        dataIndex: "account",
        align: "center",
        width: 130,
      },
      {
        title: "appKey",
        dataIndex: "appKey",
        align: "center",
        width: 130,
      },
      {
        title: "appSecret",
        dataIndex: "appSecret",
        align: "center",
        width: 130,
      },
      {
        title: "最后修改日期",
        dataIndex: "updateTime",
        align: "center",
        width: 120,
      },
      {
        title: "状态",
        dataIndex: "status",
        align: "center",
        scopedSlots: true,
        width: 100,
      },
      {
        title: "操作",
        width: 130,
        dataIndex: "options",
        align: "center",
        scopedSlots: true,
      },
    ];
    return {
      title: "",
      confirmLoading: false,
      schoolId: "",
      schoolInfo: {},
      visible: false,
      list: [],
      columns,
    };
  },
  mounted() {},
  methods: {
    open(data) {
      console.log(data);
      this.schoolId = data.id;
      this.schoolInfo = data;
      this.title = `${data.name} - 已有对接平台`;
      this.visible = true;
      this.getList();
    },
    // 获取数据
    getList() {
      this.loading = true;
      SettingSchool.projectDataDockingCompanyFindByProjectId({
        schoolId: this.schoolId,
      }).then(res => {
        if (res.code == this.config.pubCode) {
          this.list = res.data;
        }
        this.loading = false;
      });
    },
    del(id) {
      let that = this;
      this.common
        .confirm("确定解绑？")
        .then(() => {
          SettingSchool.deleteMenu({
            roleId: id,
            menuId: this.menuId,
          }).then(res => {
            if (res.code == 200) {
              that.pubMsg.tipMessage("解绑成功！", "success");
              that.handleCancel(1);
            } else {
              that.common.tipError(res.msg);
            }
            that.confirmLoading = false;
          });
        })
        .catch(() => {
          console.log("56");
        });
    },
    add(type, data) {
      this.$refs.addDockingModal.open(type, data, this.projectInfo);
    },
    // 删除
    deleteDocking(id) {
      this.pubMsg.confirm("是否确定删除此平台信息？").then(() => {
        this.loading = true;
        SettingSchool.projectDataDockingCompanyDelete({ ids: id }).then(res => {
          if (res.code == this.config.pubCode) {
            this.pubMsg.tipMessage("删除成功！", "success");
            this.loading = false;
            this.getList();
          }
        });
      });
    },
    moduleOk(data) {
      if (data) {
        this.getList();
      }
    },

    handleCancel(data) {
      this.$emit("ok", data);
      this.visible = false;
    },
  },
};
</script>
<style lang="less" scoped>
.get-role-menu {
  .role-menu-list {
    min-height: 500px;
    p {
      margin: 10px 0 0 0;
      border: 1px solid @border-color;
      padding: 5px 10px;
      position: relative;
      &:hover {
        background: #f5f5f5;
        strong {
          display: block;
        }
      }
      span {
        display: block;
        line-height: 20px;
      }
      b {
        color: #999;
        display: block;
        font-style: normal;
        font-weight: normal;
        line-height: 20px;
        em {
          color: #999;
          font-size: 12px;
          line-height: 20px;
          font-style: normal;
          margin-right: 20px;
        }
      }
      strong {
        display: none;
        position: absolute;
        top: 0;
        right: 0;
        padding: 10px;
        cursor: pointer;
        i {
          font-size: 22px;
          color: @red;
        }
      }
    }
  }
}
</style>
